var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-panel"},_vm._l((_vm.rankingItems),function(rankingItem){return _c('ol',{key:rankingItem.id,staticClass:"p-content-plan-manual-ranking-texts"},_vm._l((rankingItem.contents),function(item){return _c('ListItemContentManualText',{key:item.id,attrs:{"item":item}})}),1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }